var plugin_rtlignore_default = {
  "alignLeft": "_6csTf",
  "textWrapNowrap": "Va011",
  "alignRight": "MBsxA",
  "alignCenter": "AN6PJ",
  "sizeFullWidth": "wurfT",
  "renderedInTable": "_1CErt",
  "sizeOriginal": "FQw5F",
  "sizeContent": "dTp0V",
  "sizeSmall": "MP9rp",
  "sizeSmallCenter": "_7hB6Q",
  "flex": "dXLUA",
  "atomic": "VKuwi",
  "embed": "hxW3F",
  "horizontalScrollbar": "_9lTMy",
  "pluginContainerMobile": "_4WdhS"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
